import { Navigate } from 'react-router';
import { HasPermission } from '@/components/Permission/HasPermission';
import Unauthorized from '@/components/Unauthorized';
import { CategoryManagement, OrganizationalTitles, RolesAndPermission, Users } from '@/features/Settings';
import UserDetail from '@/features/Settings/Users/UserDetail';
import type { HasPermissionFn } from '@/hooks/usePermission/index.tsx';
import GetStarted from '../../../pages/Administration/GetStarted';
import WidgetsManagement from '../../../pages/Administration/WidgetsManagement';
import PageNotFound from '../../../pages/PageNotFound';

function IndexRoute({ hasPermission }: { hasPermission: HasPermissionFn }) {
  let path = '';
  if (hasPermission(['LIST_USERS'])) {
    path = 'users';
  } else if (hasPermission(['LIST_TITLES'])) {
    path = 'organizational-titles';
  } else if (hasPermission(['READ_ROLE'])) {
    path = 'roles-and-permissions';
  } else if (hasPermission(['LIST_CATEGORIES'])) {
    path = 'category-management';
  } else {
    return <Unauthorized />;
  }

  return <Navigate replace to={`${path}`} />;
}

export default function AdministrationRoute(hasPermission: HasPermissionFn) {
  const routesData = [
    {
      index: true,
      element: <IndexRoute hasPermission={hasPermission} />,
    },
    {
      path: 'users',
      element: (
        <HasPermission of='LIST_USERS' fallback={<Unauthorized />}>
          <Users />
        </HasPermission>
      ),
    },
    {
      path: 'users/:userId',
      element: (
        <HasPermission of='LIST_USERS' fallback={<Unauthorized />}>
          <UserDetail />
        </HasPermission>
      ),
    },
    {
      path: 'organizational-titles',
      element: (
        <HasPermission of='LIST_TITLES' fallback={<Unauthorized />}>
          <OrganizationalTitles />
        </HasPermission>
      ),
    },
    {
      path: 'roles-and-permissions',
      element: (
        <HasPermission of='READ_ROLE' fallback={<Unauthorized />}>
          <RolesAndPermission />
        </HasPermission>
      ),
    },
    {
      path: 'category-management',
      element: (
        <HasPermission of='LIST_CATEGORIES' fallback={<Unauthorized />}>
          <CategoryManagement />
        </HasPermission>
      ),
    },
    {
      path: 'widgets-management',
      element: (
        <HasPermission of='MANAGE_COMPANY_WIDGETS' fallback={<Unauthorized />}>
          <WidgetsManagement />
        </HasPermission>
      ),
    },
    {
      path: 'get-started',
      element: <GetStarted />,
    },
    {
      path: '*',
      element: <PageNotFound />,
    },
  ];

  return routesData;
}
